"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _reduxoptimisticui = require('redux-optimistic-ui');




var _log = require('shared/log');
var _store = require('shared/store');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _uuid = require('shared/services/uuid');
var _orgCreation = require('shared/services/orgCreation');

const mkMeta = (
  meta,
  type,
  id,
) => _optionalChain([meta, 'optionalAccess', _ => _.isOptimistic])
    ? { ...meta, optimistic: { type, id } }
    : meta

 const wsCommand = async ( 
  commandName,
  ac



,
  request,
  meta,
  // Whether the answer may still be stored. A caller that has since moved on
  // (a newer refresh, another account) gets the payload back, but SUCCESS is
  // not dispatched, so a stale answer never merges into the store. Not for
  // optimistic commands, whose BEGIN needs its COMMIT.
  isWanted,
  /* How long to wait for the reply; the client's default when absent. */
  ttl,
) => {
  const optimisticId = _optionalChain([meta, 'optionalAccess', _2 => _2.isOptimistic]) ? _uuid.uuidv4.call(void 0, ) : null
  _store.dispatch.call(void 0, ac.REQUEST(request, mkMeta(meta, _reduxoptimisticui.BEGIN, optimisticId)))

  // Capture here to retain the stack trace
  const cmdError = new (0, _log.CommandError)(commandName)

  const sent = ttl === undefined ? _client2.default.send(commandName, request) : _client2.default.send(commandName, request, ttl)
  return sent
    .then((payload) => {
      if (isWanted && !isWanted()) return payload
      _store.dispatch.call(void 0, ac.SUCCESS(payload, mkMeta(meta, _reduxoptimisticui.COMMIT, optimisticId)))
      return payload
    })
    .catch((e) => {
      if (e instanceof Error) {
        _log.log.error(e)
        _store.dispatch.call(void 0, ac.FAILURE(e, mkMeta(meta, _reduxoptimisticui.REVERT, optimisticId)))
        throw e
      } else {
        cmdError.addExtra(e)
        if (e.Status === 'client_error') {
          switch (commandName) {
            // An org-creation refusal (country or phone) is policy, not a bug.
            case 'CreateAndJoinOrg':
            case 'CreateOrgWithNewAdmin':
              if (!_orgCreation.getOrgCreationRefusal.call(void 0, e)) _log.log.error(cmdError)
              break
            // Don't capture unavoidable client errors
            case 'SetPassword':
              if (e.Error === 'incorrect password' || e.Error === 'weak password') break
            case 'AddPhone':
            case 'NewPatient':
            case 'ResendPhoneConfirmation':
            case 'VerifyPhone':
              if (e.Error === 'invalid phone number' || e.Error === 'unsupported region') break
              if (e.Error === 'Invalid token') break
            // Patient add-email refusals (wrong code, email taken, ...) are
            // expected; the screen explains them.
            case 'StartPatientAddEmail':
            case 'VerifyPatientAddEmail':
            // A reaction the link socket refuses (its rate limit, a message
            // gone meanwhile) is put back on the page.
            case 'AddPatientMessageReaction':
            case 'RemovePatientMessageReaction':
            case 'LoadConversationAroundMessage':
            case 'LoadConversationAroundTime':
            // Branding refusals name a field (website, Maps link, colour);
            // the settings page shows them.
            case 'SaveOrgBranding':
              break
            // A team scope for a team you've left: search shows it as no results.
            case 'Search':
              if (e.Error !== 'team not found') _log.log.error(cmdError)
              break
            // The contact cap's refusals are expected; the UI explains them.
            case 'SendMessageToConversation':
            case 'StartCampaign':
              if (e.ErrorCode !== 'contact_cap_reached' && e.ErrorCode !== 'org_not_verified') _log.log.error(cmdError)
              break
            // The pin limit is expected; the inbox explains it.
            case 'SetBlobjectPinned':
              if (e.ErrorCode !== 'pin_limit_reached') _log.log.error(cmdError)
              break
            // A stale version, a row that already moved on and a send time
            // outside the window are expected; the UI explains them.
            case 'ScheduleMessage':
            case 'EditScheduledMessage':
            case 'SendScheduledMessageNow':
            case 'CancelScheduledMessage':
            case 'DismissScheduledMessage':
              if (
                e.ErrorCode !== 'scheduled_message_changed' &&
                e.ErrorCode !== 'scheduled_message_not_scheduled' &&
                !String(e.Error).startsWith('send time must')
              ) _log.log.error(cmdError)
              break
            // A removal that would delete the user asks to confirm it (D-60).
            case 'RemoveUserFromOrg':
              if (!String(e.Error).startsWith('confirmation_required')) _log.log.error(cmdError)
              break
            default:
              _log.log.error(cmdError)
          }
        }
        _store.dispatch.call(void 0, ac.FAILURE(e, mkMeta(meta, _reduxoptimisticui.REVERT, optimisticId)))
        throw cmdError
      }
    })
}; exports.wsCommand = wsCommand

exports. default = exports.wsCommand
